/* eslint-disable no-console */
import '@/styles/app.scss'
import { createApp } from 'vue'
import CstApp from './App.vue'

import axios from 'axios'

import { ApplicationInsights } from '@microsoft/applicationinsights-web'

import Store from './store/store'
import i18n from './plugins/i18n'
import { EventBus } from './plugins/event-bus'
import ErrorHandlingInterceptor from './api/interceptors/errorHandler'
import ActivityTimer from './utils/activityTimer'
import authenticationService from '@/services/authenticationService'

import router from './router'

import ConfigDev from '../config/local.json'
import ConfigTst from '../config/tst.json'
import ConfigAcc from '../config/acc.json'
import ConfigProd from '../config/prod.json'

axios.defaults.baseURL = '/api/secured/carsalestool/'
ErrorHandlingInterceptor.errorHandlingInterceptor(axios)

window['info'] = {
  user: null,
}

var config

function getCurrentConfig(hostName) {
  hostName = hostName.toLowerCase()

  if (process.env.NODE_ENV === 'development' || hostName.match('^dev-cst.*')) return ConfigDev
  if (hostName.match('^tst-cst.*')) return ConfigTst
  if (hostName.match('^acc-cst.*')) return ConfigAcc

  return ConfigProd
}

config = getCurrentConfig(window.location.hostname)

authenticationService.setCurrentUser().then(() => {
  const app = initCstApp()
  initVueCLIExports()
  if (config.EnableApplicationInsights) initApplicationInsights()
  if (config.EnableInactivityTimer) ActivityTimer.init()

  app.mount('#vue-app')
})

function initCstApp() {
  const app = createApp({
    ...CstApp,
  })

  app.use(Store)
  app.use(i18n)
  app.use(router)

  // Register a global custom directive called `v-focus`
  app.directive('focus', {
    // When the bound element is mounted into the DOM...
    mounted(el) {
      // Focus the element
      el.focus()
    },
  })

  return app
}

function initVueCLIExports() {
  window.VUE_CLI_EXPORTS = {
    settings: { ...config, mode: process.env.NODE_ENV },
    plugins: {
      Store,
      EventBus,
    },
  }
}

function initApplicationInsights() {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: config.AppInsightsConnectionString,
      disableAjaxTracking: false,
      disableFetchTracking: false,
      autoTrackPageVisitTime: true,
      enableAutoRouteTracking: true,
    },
  })

  appInsights.loadAppInsights()

  console.defaultError = console.error.bind(console)
  console.error = function () {
    console.defaultError.apply(console, arguments)
    const userInfo = window.info.user.UserInfo

    const user = {
      id: userInfo.Id,
      DealerId: userInfo.DealerId,
    }

    if (arguments[0] instanceof Error) {
      appInsights.trackTrace({
        message: arguments[0].message,
        severityLevel: 3,
        properties: user,
      })

      appInsights.trackException({
        exception: arguments[0],
        severityLevel: 3,
      })

      appInsights.flush()
    }
  }
}
